<template>
    <div class="main-layout-section admin-portal">
        <SuperAdminHeader />
        
        <div class="w-logo mb-3">
            <img src="../../assets/images/gamelab-logo.svg" alt="logo" class="w-input-fields animate__animated animate__fadeInUp animate__delay-1s" />
        </div>

        <div class="main-content">
            <h3 class="page-subheading mb-3 animate__animated animate__fadeInUp animate__delay-1s">Manage Your Clients</h3>

            <div class="col-md-11 mx-auto">

                <div class="admin-general-section">

                    <div class="admin-general-section-buttons">
                        <router-link to="/superadmin/dashboard" class="admin-general-section-button">
                            Back To Dashboard
                        </router-link>
                        <router-link to="/superadmin/clients/deploy" class="admin-general-section-button">
                            Deploy New Client
                        </router-link>
                    </div>

                    <div class="col-sm-12">
                        <div class="overflow-auto p-0 m-0">
                            <b-table
                            id="admin-general-table"
                            :striped="true"
                            :hover="false"
                            :dark="false"
                            :items="clients"
                            :fields="fields"
                            show-empty
                            :emptyText="emptyText"
                            >
                                <template #cell(action)="data">
                                    <router-link :to="`/superadmin/clients/${data.item.id}`">
                                        <b-icon class="icon" :icon="data.value"></b-icon>
                                        View
                                    </router-link>
                                </template>
                                <template #empty="scope">
                                    <p class="text-center p-0 m-0">{{ scope.emptyText }}</p>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <!-- start of footer section -->
        <div class="col-md-12 mx-auto">
            <SuperAdminFooter type="inner" />
        </div>
        <!-- end of footer section -->
    </div>
</template>

<script>
import SuperAdminHeader from "@/views/superadmin/SuperAdminHeader.vue";
import SuperAdminFooter from "@/views/superadmin/SuperAdminFooter.vue";
import { adminGetClientsList } from "../../services/AdminService";

export default {
  name: "SuperAdminClients-view",
  components: { SuperAdminHeader, SuperAdminFooter },
  data() {
    return {
      emptyText:"No clients found at the moment!",
      emptyHtml:"No clients found at the moment!",
      fields: [{'key' : 'id', 'label' : 'ID'}, {'key' : 'value', 'label' : 'Name'}, {'key' : 'action', 'label' : 'Action'}],
      clients: [],
    };
  },

  computed: {
  },

  methods: {
    clientsList() {
      let user_data = JSON.parse(localStorage.user_sess_data);
      let params = {
        token: user_data.token
      };
      adminGetClientsList(params).then(response => {
        this.clients = response.data.clients;
        if(this.clients.length > 0) {
          this.clients.map(function(cl){
            return cl.action='eye-fill';
          });
        }
      });
    },

    makeToast(variant = "default", message) {
      this.$toast.open({
        message: message,
        type: variant,
        position: 'top-right',
        duration: 3000,
        dismissible: true
      });
    }
  },

  mounted() {
    this.clientsList();
  }

};
</script>